import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "title", "icon", "danger"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { Item } from 'rc-menu';
import toArray from 'rc-util/lib/Children/toArray';
import classNames from 'classnames';
import MenuContext from './MenuContext';
import { isValidElement, cloneElement } from '../../_utils/reactNode';
var InnerItem = function InnerItem(props) {
  var icon = props.icon,
    children = props.children,
    inlineCollapsed = props.inlineCollapsed;
  var _React$useContext = React.useContext(MenuContext),
    prefixCls = _React$useContext.prefixCls,
    firstLevel = _React$useContext.firstLevel;
  var wrapNode = React.createElement("span", {
    className: "".concat(prefixCls, "-title-content")
  }, children);
  if (!icon || isValidElement(children) && children.type === 'span') {
    if (children && inlineCollapsed && firstLevel && typeof children === 'string') {
      return React.createElement("div", {
        className: "".concat(prefixCls, "-inline-collapsed-noicon")
      }, children.charAt(0));
    }
  }
  return wrapNode;
};
export var MenuItem = function MenuItem(props) {
  var _classNames;
  var _a;
  var className = props.className,
    children = props.children,
    title = props.title,
    icon = props.icon,
    danger = props.danger,
    rest = _objectWithoutProperties(props, _excluded);
  var _React$useContext2 = React.useContext(MenuContext),
    prefixCls = _React$useContext2.prefixCls,
    inlineCollapsed = _React$useContext2.inlineCollapsed;
  var childrenLength = toArray(children).length;
  return React.createElement(Item, _objectSpread(_objectSpread({}, rest), {}, {
    className: classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-danger"), danger), _defineProperty(_classNames, "".concat(prefixCls, "-item-only-child"), (icon ? childrenLength + 1 : childrenLength) === 1), _classNames), className),
    title: typeof title === 'string' ? title : undefined
  }), cloneElement(icon, {
    className: classNames(isValidElement(icon) ? (_a = icon.props) === null || _a === void 0 ? void 0 : _a.className : '', "".concat(prefixCls, "-item-icon"))
  }), React.createElement(InnerItem, {
    inlineCollapsed: inlineCollapsed,
    icon: icon
  }, children));
};